import { HardHat } from '@phosphor-icons/react'
import { PageHeading, Panel } from '../components/common'

export function PlaceholderPage({ title, description }: { title: string; description: string }) {
  return (
    <section className="page-stack">
      <PageHeading title={title} description={description} />
      <Panel className="placeholder-panel"><HardHat size={36} weight="duotone" /><strong>此頁已保留</strong><p>既有 Dashboard 功能穩定後，再依實際使用需求加入。</p></Panel>
    </section>
  )
}
